import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { TrackEventContext } from 'common/containers/EventContainer';
import { ShowIntercomContext } from 'common/containers/IntercomContainer';
import { ViewerContext } from 'common/containers/ViewerContainer';
import LandingPricingHelmet from 'common/helmets/LandingPricingHelmet';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LandingLogos from 'common/LandingLogos';
import Link from 'common/Link';
import Tappable from 'common/Tappable';
import withContexts from 'common/util/withContexts';
import PricingV3 from 'common/www/PricingV3';

import 'css/components/www/_LandingPricingPage.scss';

class LandingPricingPage extends Component {
  static propTypes = {
    router: PropTypes.object,
    showIntercom: PropTypes.func,
    trackEvent: PropTypes.func,
    viewer: PropTypes.object,
  };

  componentDidMount() {
    const { trackEvent } = this.props;
    trackEvent('Viewed Pricing Page');
    trackEvent('Looked at pricing');
  }

  onContactUsTapped = () => {
    this.props.showIntercom();
  };

  onPricingButtonTapped = (plan) => {
    this.props.router.push('/register');
  };

  renderSpecialPricing() {
    return (
      <div className="specialPricing" id="specialPricingOptions">
        <div className="special">
          <div className="text">
            <div className="title">
              Discounts for&nbsp;startups
              <div className="price">
                $100
                <div className="month">/ mo</div>
              </div>
            </div>
            <div className="description">
              We offer discounts on the Growth plan for early-stage companies. 75%&nbsp;off for your
              first year. 50%&nbsp;off for your&nbsp;second.
            </div>
            <div className="spacer" />
            <Tappable onTap={this.onContactUsTapped}>
              <div className="contactUs">Contact us to see if you qualify</div>
            </Tappable>
          </div>
        </div>
        <div className="special">
          <div className="text">
            <div className="title">Annual&nbsp;discounts</div>
            <div className="description">Save up to 15% by paying for a year&nbsp;upfront.</div>
            <div className="spacer" />
            <Tappable onTap={this.onContactUsTapped}>
              <div className="contactUs">Contact us</div>
            </Tappable>
          </div>
        </div>
        <div className="special">
          <div className="text">
            <div className="title">Special plans for special&nbsp;companies</div>
            <div className="description">
              We offer discounts to companies working in healthcare, non-profit, and&nbsp;education.
            </div>
            <div className="spacer" />
            <Tappable onTap={this.onContactUsTapped}>
              <div className="contactUs">Contact us to see if you qualify</div>
            </Tappable>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="landingPricingPage">
        <LandingPricingHelmet />
        <div className="landingPricingPageContainer">
          <div className="heading">
            <div className="text">
              <h1>Canny costs less than building the wrong&nbsp;features</h1>
              <div className="subtitle">
                Start free and see what you <span className="italics">should</span> be
                working&nbsp;on
              </div>
            </div>
          </div>
          <PricingV3 />
          {this.renderSpecialPricing()}
          <LandingLogos />
          <Link to="/case-studies" className="caseStudiesCTA">
            Learn more about how other teams use&nbsp;Canny&nbsp;&rarr;
          </Link>
          <LandingFooterCTA style="solid" />
        </div>
      </div>
    );
  }
}

export default withContexts({
  showIntercom: ShowIntercomContext,
  trackEvent: TrackEventContext,
  viewer: ViewerContext,
})(LandingPricingPage);
